import type { PaginatedAdminIssuerListList } from 'api';

export enum IssuerActions {
  LOAD_APP = 'ISSUER/LOAD_APP',
  ISSUERS_FETCH = 'ISSUER/ISSUERS_FETCH',
  ISSUERS_FETCH_SUCCESS = 'ISSUER/ISSUERS_FETCH_SUCCESS',
  ISSUERS_FETCH_FAILURE = 'ISSUER/ISSUERS_FETCH_FAILURE',
}

export type LoadIssuerApp = { type: IssuerActions.LOAD_APP };
export type IssuersFetch = { type: IssuerActions.ISSUERS_FETCH };
export type IssuersFetchSuccess = {
  type: IssuerActions.ISSUERS_FETCH_SUCCESS;
  data: PaginatedAdminIssuerListList;
};
export type IssuersFetchFailure = {
  type: IssuerActions.ISSUERS_FETCH_FAILURE;
  error: Error;
};

export type IssuerActionTypes = LoadIssuerApp | IssuersFetch | IssuersFetchSuccess | IssuersFetchFailure;

export function loadIssuerApp(): LoadIssuerApp {
  return {
    type: IssuerActions.LOAD_APP,
  };
}

export function issuersFetch(): IssuersFetch {
  return {
    type: IssuerActions.ISSUERS_FETCH,
  };
}

export function issuersFetchSuccess(data: PaginatedAdminIssuerListList): IssuersFetchSuccess {
  return {
    type: IssuerActions.ISSUERS_FETCH_SUCCESS,
    data,
  };
}

export function issuersFetchFailure(error: Error): IssuersFetchFailure {
  return {
    type: IssuerActions.ISSUERS_FETCH_FAILURE,
    error,
  };
}
